import { CookiesStorageService } from '@/services/cookiesStorageService';
import { getChosenCookies } from '@/helpers/getChosenCookies';
import { getTrafficSource } from '@/helpers/getTrafficSource';
import { ENV } from '@/constants';

declare let google_tag_manager: any;
declare let google_tag_data: any;
declare let dataLayer: any;

let GoogleInitializationOnce = false;
export const GoogleService = {
	initialization(callback?: () => void) {
		if (!GoogleInitializationOnce) {
			GoogleInitializationOnce = true;

			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.text = `
				(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer','${ENV.GTM_ID}');
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '${ENV.GTAG_ID}', {
					'send_page_view': false,
					'page_path': window.location.pathname,
				});
				${callback?.()};
			`;
			document.body.appendChild(script);

			const noscriptEl = document.createElement('noscript');
			const iframeEl = document.createElement('iframe');
			iframeEl.setAttribute(
				'src',
				`https://www.googletagmanager.com/ns.html?id=${ENV.GTM_ID}`,
			);
			iframeEl.style.width = '0';
			iframeEl.style.height = '0';
			iframeEl.style.display = 'none';
			iframeEl.style.visibility = 'hidden';

			noscriptEl.appendChild(iframeEl);
			document.body.appendChild(noscriptEl);
		}
	},
	// INFO: not sure if this method is work correct
	// pageview(url: string) {
	// 	if (getChosenCookies('marketing') && (window as any).gtag && ENV.GTAG_ID) {
	// 		// @ts-ignore
	// 		gtag('config', ENV.GTAG_ID, {
	// 			page_path: url,
	// 		});
	// 	}
	// },
	GTMPageview(url: string) {
		if (getChosenCookies('marketing') && getTrafficSource().allowGoogle) {
			(window as any).dataLayer?.push({
				event: 'pageview',
				page: url,
			});
		}
	},
	setClientId() {
		if (
			getChosenCookies('marketing') &&
			getTrafficSource().allowGoogle &&
			(window as any).gtag &&
			ENV.GTAG_ID
		) {
			gtag('get', ENV.GTAG_ID, 'client_id', clientID => {
				CookiesStorageService.set('client_id', clientID);
			});
		}
	},
	logEvent(event: string, eventProperties?: object) {
		if (
			getChosenCookies('marketing') &&
			getTrafficSource().allowGoogle &&
			(window as any).gtag
		) {
			gtag('event', event, eventProperties);
		}
	},
	remove() {
		if (
			GoogleInitializationOnce &&
			(window as any).google_tag_manager &&
			(window as any).google_tag_data &&
			(window as any).dataLayer
		) {
			// Remove all external GTM scripts
			const removeScripts = () => {
				document
					.querySelectorAll('script[src*="googletagmanager"]')
					.forEach(script => {
						script.remove();
					});
			};

			// Remove inline script if it contains 'googletagmanager.com/gtm.js'
			const removeInlineScripts = () => {
				document.querySelectorAll('script').forEach(script => {
					if (script.innerHTML.includes('googletagmanager.com/gtm.js')) {
						script.remove();
					}
				});
			};

			// Remove all GTM noscript elements
			const removeNoscripts = () => {
				document
					.querySelectorAll('noscript iframe[src*="googletagmanager"]')
					.forEach(iframe => {
						iframe.remove();
					});
			};

			// Execute removal of GTM scripts, inline scripts, and noscripts
			removeScripts();
			removeInlineScripts();
			removeNoscripts();

			// Delete or reset global variables related to GTM
			delete (window as any).google_tag_manager;
			delete (window as any).google_tag_data;
			(window as any).dataLayer = []; // reset dataLayer to an empty array

			console.log('Google Analytics scripts and noscripts removed');
		}
	},
};
